var React = require('react');

function Npm (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M288 288h-32v-64h32v64zm288-128v192H288v32H160v-32H0V160h576zm-416 32H32v128h64v-96h32v96h32V192zm160 0H192v160h64v-32h64V192zm224 0H352v128h64v-96h32v96h32v-96h32v96h32V192z"}));
}

Npm.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = Npm;

Npm.default = Npm;
